import { useState } from "react";

const faqs = [
  {
    question: "¿Es realmente gratuito el estudio energético?",
    answer:
      "Sí, el estudio inicial es completamente gratuito y sin compromiso. Analizamos tus facturas, identificamos oportunidades de ahorro y te presentamos un informe detallado. Solo seguimos trabajando juntos si tú lo decides.",
  },
  {
    question: "¿Cuánto tiempo lleva el proceso?",
    answer:
      "El estudio inicial se completa en 24-48 horas una vez que nos envías tus últimas facturas. Si decides proceder con la optimización, el proceso completo suele completarse en 1-2 semanas.",
  },
  {
    question: "¿Trabajan con todos los tipos de suministro?",
    answer:
      "Sí, trabajamos con suministros eléctricos y de gas natural para particulares, pymes, comunidades de propietarios y negocios de cualquier tamaño, tanto en mercado libre como regulado.",
  },
  {
    question: "¿Tengo que cambiar de comercializadora?",
    answer:
      "No necesariamente. A veces la optimización pasa por mejorar las condiciones con tu comercializadora actual. Si hay una alternativa mejor en el mercado, te lo explicamos con datos para que decidas con total libertad.",
  },
  {
    question: "¿Cómo sé si realmente me están cobrando bien?",
    answer:
      "La mayoría de los consumidores no saben interpretar su factura energética. Nosotros la revisamos línea a línea para verificar que todos los conceptos sean correctos: potencia, energía, impuestos, peajes y cargos regulados.",
  },
  {
    question: "¿Qué pasa con los cambios del mercado energético?",
    answer:
      "Con nuestro servicio de acompañamiento continuo te mantenemos informado de los cambios que puedan afectarte y te avisamos proactivamente cuando hay oportunidades de mejorar tus condiciones.",
  },
  {
    question: "¿Trabajan con comunidades de propietarios?",
    answer:
      "Sí, ofrecemos un servicio especializado para comunidades. Analizamos los suministros de zonas comunes (garajes, ascensores, iluminación) y gestionamos los cambios de forma colectiva para maximizar el ahorro.",
  },
  {
    question: "¿Cómo me ayudan con el autoconsumo solar?",
    answer:
      "Te asesoramos sobre la viabilidad de una instalación fotovoltaica, el retorno de inversión, las subvenciones disponibles, los trámites necesarios y la mejor configuración según tu perfil de consumo.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 bg-faro-gray">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-faro-teal text-sm font-semibold uppercase tracking-widest">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-faro-navy mt-3 mb-4">
            Preguntas frecuentes
          </h2>
          <p className="text-faro-gray-text text-lg max-w-xl mx-auto">
            Resolvemos las dudas más habituales sobre nuestros servicios y el proceso de optimización energética.
          </p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
                openIndex === index
                  ? "border-faro-teal/30"
                  : "border-faro-gray-mid"
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span
                  className={`text-base font-medium pr-4 ${
                    openIndex === index ? "text-faro-teal" : "text-faro-navy"
                  }`}
                >
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors duration-200 ${
                  openIndex === index ? "bg-faro-teal-pale text-faro-teal" : "bg-faro-gray text-faro-gray-text"
                }`}>
                  <i
                    className={`ri-${openIndex === index ? "subtract" : "add"}-line text-sm`}
                  />
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-faro-gray-text text-sm leading-relaxed border-t border-faro-gray-mid pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
